var _rect, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPermissions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 69,
    viewBox: "0 0 68 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    rx: 10,
    transform: "matrix(0.999914 0.0130896 0 1 0 0)",
    fill: "#E5F7FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7022 54.2894H40.3033C50.8042 54.2894 55.0046 50.1436 55.0046 39.7793V27.3421C55.0046 16.9778 50.8042 12.832 40.3033 12.832H27.7022C17.2013 12.832 13.001 16.9778 13.001 27.3421V39.7793C13.001 50.1436 17.2013 54.2894 27.7022 54.2894Z",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9915 36.8982C40.6183 39.2405 37.2161 39.966 34.2128 39.0332L28.7733 44.3812C28.3953 44.775 27.6182 45.0238 27.0512 44.9409L24.531 44.6092C23.6909 44.5056 22.9348 43.7179 22.8088 42.9095L22.4728 40.422C22.3888 39.8831 22.6618 39.1161 23.0398 38.7223L28.4583 33.3743C27.5342 30.4101 28.2483 27.052 30.6215 24.7097C34.0238 21.3517 39.5683 21.3517 42.9915 24.7097C46.3938 28.047 46.3938 33.5194 42.9915 36.8982Z",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7474 42.4326L28.9624 40.6499",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9315 30.866H36.9504",
    stroke: "#009FFF",
    strokeWidth: 2.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/permissions.abc4cb11fe7bc2c2c51b99ba34d4c828.svg";
export { ForwardRef as ReactComponent };